(()=>{
function init(scope=document){
  scope.querySelectorAll('[data-visual-product]').forEach(root=>{
    if(root.dataset.choicesReady)return;
    const master=root.querySelector('[data-variant-master]');
    const requiredBoxId=Number(root.dataset.requiredBoxId||0);
    const requiredBoxPrice=Number(root.dataset.requiredBoxPrice||0);
    const requiredBoxAvailable=root.dataset.requiredBoxAvailable!=='false';
    const boxMissing=root.dataset.boxRequired==='true'&&(!requiredBoxId||!requiredBoxAvailable);
    const retry=root.querySelector('[data-variant-retry]');
    const groups=[...root.querySelectorAll('[data-option-index]')];
    const button=root.querySelector('[data-product-submit]');
    if(!master||!button)return;
    let variants;
    try{
      variants=[...master.options].map(o=>({
        id:o.value, options:JSON.parse(o.dataset.options),
        available:o.dataset.available==='true',price:o.dataset.price,
        cents:Number(o.dataset.priceCents),imageId:o.dataset.imageId||''
      }));
    }catch(e){return;}
    if(!variants.length)return;
    root.dataset.choicesReady='true';
    groups.forEach(group=>{
      const grid=group.querySelector('.choice-grid');
      if(!grid)return;
      const cards=[...grid.querySelectorAll('.choice-card')].map((node,index)=>{
        const rank=Number(node.dataset.choiceOrder);
        return {node,index,rank:Number.isFinite(rank)?rank:100000};
      });
      cards.sort((a,b)=>a.rank-b.rank||a.index-b.index);
      cards.forEach(card=>grid.appendChild(card.node));
    });

    const price=root.querySelector('[data-product-price]');
    const status=root.querySelector('[data-variant-status]');
    const qty=root.querySelector('input[name="quantity"]');
    const pricePosition=root.querySelector('[data-price-position]');
    const purchaseBar=root.querySelector('[data-purchase-bar]');
    const quantityControls=root.querySelector('[data-quantity-controls]');
    const quantityActions=[...root.querySelectorAll('[data-quantity-action]')];
    function quantityValue(){
      const minimum=Math.max(1,Number(qty?.min)||1);
      const rawMaximum=Number(qty?.max);
      const maximum=Number.isFinite(rawMaximum)&&rawMaximum>=minimum?rawMaximum:Number.MAX_SAFE_INTEGER;
      const value=Number(qty?.value);
      return Math.min(maximum,Math.max(minimum,Number.isFinite(value)?Math.floor(value):minimum));
    }
    function syncQuantityControls(){
      const count=quantityValue();
      const minimum=Math.max(1,Number(qty?.min)||1);
      const maximum=Number(qty?.max);
      const busy=root.dataset.addingBox==='true';
      if(qty)qty.readOnly=busy;
      quantityActions.forEach(control=>{
        const action=control.dataset.quantityAction;
        control.disabled=busy||(action==='minus'&&count<=minimum)||(action==='reset'&&count===minimum)||(action==='plus'&&maximum>=minimum&&count>=maximum);
      });
    }
    if(quantityControls&&qty){
      quantityControls.hidden=false;
      quantityActions.forEach(control=>control.addEventListener('click',()=>{
        if(root.dataset.addingBox==='true')return;
        const current=quantityValue();
        const action=control.dataset.quantityAction;
        const minimum=Math.max(1,Number(qty.min)||1);
        qty.value=String(action==='reset'?minimum:action==='minus'?current-1:Math.min(Number.MAX_SAFE_INTEGER,current+1));
        qty.value=String(quantityValue());
        update();
        syncQuantityControls();
      }));
    }
    let priceUpdatePending=false;
    function refreshPricePosition(){
      priceUpdatePending=false;
      if(!pricePosition||!purchaseBar||!root.isConnected)return;
      const viewport=window.visualViewport;
      const viewTop=viewport?.offsetTop||0;
      const viewHeight=viewport?.height||window.innerHeight||document.documentElement.clientHeight;
      const viewWidth=viewport?.width||window.innerWidth||document.documentElement.clientWidth;
      const viewLeft=viewport?.offsetLeft||0;
      const header=document.querySelector('.site-header-section');
      const headerBottom=header?Math.max(viewTop,header.getBoundingClientRect().bottom):viewTop;
      const barHeight=purchaseBar.offsetHeight;
      if(barHeight>0&&!purchaseBar.classList.contains('is-floating'))pricePosition.style.minHeight=barHeight+'px';
      const bounds=pricePosition.getBoundingClientRect();
      const fullyVisible=bounds.top>=headerBottom+8&&bounds.bottom<=viewTop+viewHeight-12;
      const width=Math.min(bounds.width,viewWidth-24);
      const left=Math.max(viewLeft+12,Math.min(bounds.left,viewLeft+viewWidth-width-12));
      const keyboardInset=Math.max(0,(window.innerHeight||viewHeight)-viewTop-viewHeight);
      purchaseBar.style.setProperty('--purchase-left',left+'px');
      purchaseBar.style.setProperty('--purchase-width',Math.max(0,width)+'px');
      purchaseBar.style.setProperty('--purchase-bottom',(keyboardInset+12)+'px');
      purchaseBar.classList.toggle('is-floating',!fullyVisible);
      document.body.style.setProperty('--purchase-bar-height',purchaseBar.offsetHeight+'px');
    }
    function schedulePricePosition(){
      if(priceUpdatePending)return;
      priceUpdatePending=true;
      window.requestAnimationFrame(refreshPricePosition);
    }
    const locale=root.dataset.locale||'pt-PT';
    const currency=root.dataset.currency||'EUR';
    const money=cents=>{
      try{return new Intl.NumberFormat(locale,{style:'currency',currency}).format(cents/100);}
      catch(e){return (cents/100).toFixed(2).replace('.',',')+' €';}
    };
    // Shopify apresenta no máximo 250 variantes em product.variants no Liquid.
    // Resolver diretamente a combinação escolhida através da Section Rendering API.
    // Isto mantém as restantes variantes (>250) e novas variantes compráveis.
    const sectionId=root.dataset.sectionId;
    const productUrl=root.dataset.productUrl;
    const verifyBundlePrice=root.dataset.bundleIntegrity==='true';
    const readCents=value=>typeof value==='string'&&/^\d+$/.test(value)&&Number.isSafeInteger(Number(value))?Number(value):null;
    let includedBoxPrice=readCents(root.dataset.includedBoxPrice);
    let resolutionSerial=0;
    let resolutionController=null;
    let activeVariant=null;
    let submissionPending=false;
    let compositionChanged=false;
    const compositionMessage='A composição deste conjunto foi atualizada. Recarregue a página para ver os artigos e confirmar a seleção.';
    const selectedChoices=()=>groups.map(group=>group.querySelector('[data-choice]:checked'));
    const sameOptions=(left,right)=>Array.isArray(left)&&left.length===right.length&&left.every((value,index)=>value===right[index]);
    const choiceKey=choices=>JSON.stringify(choices.map(choice=>[choice?.value,choice?.dataset.optionValueId]));
    function componentTotal(choices,boxPrice=includedBoxPrice){
      if(!choices.length||boxPrice===null)return null;
      let total=boxPrice;
      for(const choice of choices){
        const cents=readCents(choice?.dataset.choicePriceCents);
        if(cents===null||!choice?.dataset.choiceSourceId||choice.dataset.choiceMappedSourceId!==choice.dataset.choiceSourceId)return null;
        total+=cents;
      }
      return Number.isSafeInteger(total)?total:null;
    }
    function consistentPrice(variant,choices=selectedChoices(),boxPrice=includedBoxPrice){
      return !!variant?.id&&Number.isSafeInteger(variant.cents)&&variant.cents>=0&&(!verifyBundlePrice||componentTotal(choices,boxPrice)===variant.cents);
    }
    function priceSignature(variant,choices=selectedChoices()){
      return JSON.stringify([variant?.id,variant?.cents,quantityValue(),includedBoxPrice,choices.map(choice=>[choice?.value,choice?.dataset.optionValueId,choice?.dataset.choiceSourceId,choice?.dataset.choiceMappedSourceId,choice?.dataset.choicePriceCents])]);
    }
    function cancelResolution(){
      resolutionController?.abort();
      return ++resolutionSerial;
    }
    function showProblem(message){
      activeVariant=null;
      master.value='';
      master.disabled=true;
      button.disabled=true;
      button.textContent='Seleção por confirmar';
      if(price)price.textContent='—';
      if(status)status.textContent=message;
      if(retry)retry.hidden=compositionChanged;
      syncQuantityControls();
      schedulePricePosition();
    }
    function showVariant(v){
      if(v&&!consistentPrice(v)){
        showProblem('O preço desta combinação precisa de ser confirmado. Experimente outra opção ou contacte-nos.');
        return;
      }
      activeVariant=v||null;
      if(status)status.textContent=boxMissing?'A embalagem deste cabaz está indisponível. Contacte-nos para uma alternativa.':'';
      if(retry)retry.hidden=true;
      const valid=!!v?.id;
      if(valid){
        const id=String(v.id);
        let option=[...master.options].find(o=>o.value===id);
        if(!option){
          option=document.createElement('option');
          option.value=id;
          option.textContent=v.options.join(' / ');
          master.append(option);
        }
        option.dataset.options=JSON.stringify(v.options);
        option.dataset.priceCents=String(v.cents);
        option.dataset.available=String(!!v.available);
        option.dataset.imageId=v.imageId||'';
        option.disabled=!v.available;
        master.value=id;
      }else{
        master.value='';
      }
      master.disabled=!valid||!v.available;
      button.disabled=root.dataset.addingBox==='true'||!valid||!v.available||boxMissing;
      button.textContent=boxMissing?'Embalagem indisponível':!valid?'Escolha outra opção':v.available?'Adicionar ao carrinho':'Esgotado';
      const count=quantityValue();
      if(price)price.textContent=valid&&Number.isFinite(v.cents)?money((v.cents+requiredBoxPrice)*count):'—';
      syncQuantityControls();
      schedulePricePosition();
      if(valid)root.dispatchEvent(new CustomEvent('feitoria:variant-change',{detail:{variantId:String(v.id),imageId:v.imageId||''}}));
    }
    async function resolveFresh(forSubmission=false){
      if(compositionChanged){showProblem(compositionMessage);return null;}
      const choices=selectedChoices();
      const selected=choices.map(choice=>choice?.value);
      const ids=choices.map(choice=>choice?.dataset.optionValueId);
      if(!sectionId||!productUrl||selected.some(value=>!value)||ids.some(value=>!value)){
        cancelResolution();
        showProblem('Não foi possível confirmar a seleção. Tente novamente.');
        return null;
      }
      const before=forSubmission?priceSignature(activeVariant,choices):null;
      const key=choiceKey(choices);
      const serial=cancelResolution();
      const controller=new AbortController();
      resolutionController=controller;
      let timedOut=false;
      const timer=window.setTimeout(()=>{timedOut=true;controller.abort();},10000);
      master.value='';
      master.disabled=true;
      button.disabled=true;
      button.textContent=forSubmission?'A confirmar o preço...':'A atualizar...';
      if(price)price.textContent='…';
      if(status)status.textContent='';
      if(retry)retry.hidden=true;
      try{
        const url=new URL(productUrl,window.location.origin);
        const preview=new URLSearchParams(window.location.search).get('preview_theme_id');
        if(preview)url.searchParams.set('preview_theme_id',preview);
        url.searchParams.set('section_id',sectionId);
        url.searchParams.set('option_values',ids.join(','));
        url.searchParams.set('_fs_price_check',Date.now()+'-'+serial);
        const response=await fetch(url.toString(),{signal:controller.signal,cache:'no-store',headers:{'Accept':'text/html'}});
        if(!response.ok)throw Error('selection');
        const html=await response.text();
        if(serial!==resolutionSerial||choiceKey(selectedChoices())!==key)return null;
        const doc=new DOMParser().parseFromString(html,'text/html');
        const remoteRoot=doc.querySelector('[data-visual-product]');
        const result=remoteRoot?.querySelector('[data-variant-resolution]');
        if(!result||remoteRoot.dataset.productId!==root.dataset.productId)throw Error('selection');
        const resolvedOptions=JSON.parse(result.dataset.variantOptions||'null');
        const id=result.dataset.variantId;
        const cents=readCents(result.dataset.variantPriceCents);
        if(!id||cents===null||!sameOptions(resolvedOptions,selected))throw Error('selection');
        const found={id,options:resolvedOptions,available:result.dataset.variantAvailable==='true',cents,imageId:result.dataset.variantImageId||''};
        if(verifyBundlePrice){
          if(remoteRoot.dataset.bundleIntegrity!=='true')throw Error('price');
          const remoteGroups=[...remoteRoot.querySelectorAll('[data-option-index]')];
          const remoteChoices=choices.map((choice,index)=>{
            const group=remoteGroups.find(group=>group.dataset.optionIndex===groups[index].dataset.optionIndex);
            return [...(group?.querySelectorAll('[data-choice]')||[])].find(item=>item.dataset.optionValueId===ids[index]&&item.value===selected[index]);
          });
          const remoteBoxPrice=readCents(remoteRoot.dataset.includedBoxPrice);
          if(!consistentPrice(found,remoteChoices,remoteBoxPrice))throw Error('price');
          if(choices.some((choice,index)=>choice.dataset.choiceSourceId!==remoteChoices[index].dataset.choiceSourceId||choice.dataset.choiceMappedSourceId!==remoteChoices[index].dataset.choiceMappedSourceId))throw Error('composition');
          choices.forEach((choice,index)=>{
            choice.dataset.choicePriceCents=remoteChoices[index].dataset.choicePriceCents;
            choice.dataset.choiceSourceId=remoteChoices[index].dataset.choiceSourceId;
            choice.dataset.choiceMappedSourceId=remoteChoices[index].dataset.choiceMappedSourceId;
            const label=choice.closest('.choice-card')?.querySelector('[data-choice-price]');
            if(label)label.textContent=money(readCents(choice.dataset.choicePriceCents));
          });
          includedBoxPrice=remoteBoxPrice;
          root.dataset.includedBoxPrice=String(remoteBoxPrice);
          const caption=root.querySelector('[data-included-box-caption]');
          const remoteCaption=remoteRoot.querySelector('[data-included-box-caption]');
          if(caption&&remoteCaption)caption.textContent=remoteCaption.textContent;
        }
        variants=variants.filter(variant=>variant.id!==found.id&&!sameOptions(variant.options,found.options));
        variants.push(found);
        showVariant(found);
        if(forSubmission&&before!==priceSignature(found)){
          if(status)status.textContent='O preço ou a seleção foi atualizado. Confira o total e volte a adicionar ao carrinho.';
          return null;
        }
        return found;
      }catch(error){
        if(serial!==resolutionSerial||(error.name==='AbortError'&&!timedOut))return null;
        if(error.message==='composition')compositionChanged=true;
        showProblem(compositionChanged?compositionMessage:error.message==='price'?'O preço desta combinação precisa de ser confirmado. Experimente outra opção ou contacte-nos.':'Não foi possível confirmar a seleção. Tente novamente.');
        return null;
      }finally{
        window.clearTimeout(timer);
      }
    }
    function update(force=false){
      if(root.dataset.addingBox==='true')return;
      if(compositionChanged){showProblem(compositionMessage);return;}
      if(!groups.length){showVariant(variants.find(v=>v.id===master.value)||variants[0]);return;}
      const selected=groups.map(g=>g.querySelector('[data-choice]:checked')?.value);
      if(selected.some(x=>!x)){
        cancelResolution();
        showVariant(null);
        return;
      }
      const known=variants.find(v=>v.options.length===selected.length&&v.options.every((o,i)=>o===selected[i]));
      if(force!==true&&known&&consistentPrice(known)){
        cancelResolution();
        showVariant(known);
        return;
      }
      void resolveFresh();
    }
    const options=root.querySelector('[data-option-groups]');
    if(options)options.hidden=false;
    master.hidden=true;
    // Impede que o browser foque o radio invisível e desloque a página.
    // Regista a posição antes do toque, para também corrigir o scroll automático no iOS.
    let selectionScrollY=null;
    groups.forEach(g=>{
      g.addEventListener('pointerdown',event=>{
        if(event.target.closest('.choice-card')) selectionScrollY=window.scrollY;
      },{passive:true});
      g.addEventListener('click',event=>{
        const label=event.target.closest('.choice-card');
        if(!label||!g.contains(label))return;
        const radio=label.querySelector('[data-choice]');
        if(!radio||radio.disabled)return;
        if(event.target===radio)return;
        const keepY=selectionScrollY===null?window.scrollY:selectionScrollY;
        selectionScrollY=null;
        event.preventDefault();
        radio.focus({preventScroll:true});
        if(!radio.checked){radio.checked=true;radio.dispatchEvent(new Event('change',{bubbles:true}));}
        else if(retry&&!retry.hidden)update(true);
        // Restaura a posição após a atualização visual, sem animação.
        const restore=()=>{
          if(Math.abs(window.scrollY-keepY)>2){
            const html=document.documentElement;
            const old=html.style.scrollBehavior;
            html.style.scrollBehavior='auto';
            window.scrollTo({top:keepY,behavior:'instant'});
            html.style.scrollBehavior=old;
          }
        };
        restore();
        requestAnimationFrame(()=>{restore();requestAnimationFrame(restore);});
      });
    });
    // PC: arrastar as fotografias/cartões com o rato desloca a faixa horizontal.
    // Cliques normais continuam a selecionar opções; arrastar não as seleciona.
    groups.forEach(g=>{
      const grid=g.querySelector('.choice-grid');
      if(!grid)return;
      let active=false, didDrag=false, startX=0, startY=0, originalScroll=0;
      let pointerId=null, ignoreClickUntil=0;
      const move=e=>{
        if(!active||e.pointerId!==pointerId)return;
        const dx=e.clientX-startX,dy=e.clientY-startY;
        if(!didDrag){
          if(Math.abs(dx)<8||Math.abs(dx)<Math.abs(dy)*1.2)return;
          didDrag=true;
          grid.classList.add('is-mouse-dragging');
          if(window.getSelection)window.getSelection()?.removeAllRanges();
        }
        grid.scrollLeft=originalScroll-dx;
        if(e.cancelable)e.preventDefault();
      };
      const stop=e=>{
        if(!active||e.pointerId!==pointerId)return;
        active=false;
        if(didDrag)ignoreClickUntil=performance.now()+400;
        grid.classList.remove('is-mouse-dragging');
        document.removeEventListener('pointermove',move,true);
        document.removeEventListener('pointerup',stop,true);
        document.removeEventListener('pointercancel',stop,true);
      };
      grid.addEventListener('pointerdown',e=>{
        if(e.pointerType!=='mouse'||e.button!==0||grid.scrollWidth<=grid.clientWidth+2)return;
        active=true;didDrag=false;pointerId=e.pointerId;
        startX=e.clientX;startY=e.clientY;originalScroll=grid.scrollLeft;
        document.addEventListener('pointermove',move,{capture:true,passive:false});
        document.addEventListener('pointerup',stop,true);
        document.addEventListener('pointercancel',stop,true);
      });
      grid.addEventListener('click',e=>{
        if(performance.now()<ignoreClickUntil){
          ignoreClickUntil=0;
          e.preventDefault();e.stopImmediatePropagation();
        }
      },true);
      grid.addEventListener('dragstart',e=>{
        if(e.target.closest('.choice-card'))e.preventDefault();
      });
      grid.querySelectorAll('img').forEach(img=>{img.draggable=false;});
    });
    groups.forEach(g=>g.addEventListener('change',update));
    retry?.addEventListener('click',()=>update(true));
    master.addEventListener('change',update);
    qty?.addEventListener('input',()=>{update();syncQuantityControls();});
    qty?.addEventListener('change',()=>{qty.value=String(quantityValue());update();syncQuantityControls();});
    master.form?.addEventListener('submit',async e=>{
      e.preventDefault();
      if(button.disabled||!master.value||submissionPending||root.dataset.addingBox==='true'||!window.FeitoriaCartAdd)return;
      const cartAdd=window.FeitoriaCartAdd,form=master.form;
      if(!form.reportValidity())return;
      if(verifyBundlePrice){
        submissionPending=true;
        let verified;
        try{verified=await resolveFresh(true);}
        finally{submissionPending=false;}
        if(!verified||button.disabled||master.value!==String(verified.id))return;
      }
      const quantity=quantityValue(),payload=new FormData(form);
      payload.set('quantity',String(quantity));
      let request=payload;
      if(requiredBoxId){
        const group='FS-BOX-'+(window.crypto?.randomUUID?.()||Date.now().toString(36)+'-'+Math.random().toString(36).slice(2));
        const mainProperties={_cabaz_group:group};
        for(const [name,value] of payload.entries()){
          const property=name.match(/^properties\[(.+)\]$/);
          if(property&&typeof value==='string'&&value.trim())mainProperties[property[1]]=value.trim();
        }
        const productItem={id:Number(master.value),quantity,properties:mainProperties};
        const plan=payload.get('selling_plan');if(plan)productItem.selling_plan=Number(plan);
        request={items:[productItem,{id:requiredBoxId,quantity,properties:{_cabaz_group:group,_embalagem_obrigatoria:'true'}}]};
      }
      root.dataset.addingBox='true';
      const unlock=cartAdd.lock(form);
      syncQuantityControls();
      button.textContent=cartAdd.words().adding;
      if(status)status.textContent='';
      let added=false,failure;
      try{
        const result=await cartAdd.add(root.dataset.addUrl,request);
        if(requiredBoxId&&(!Array.isArray(result.items)||request.items.some(expected=>result.items.filter(item=>Number(item.variant_id||item.id)===expected.id&&item.properties?._cabaz_group===expected.properties._cabaz_group).reduce((sum,item)=>sum+item.quantity,0)!==expected.quantity)))throw new Error(cartAdd.words().error+' '+cartAdd.words().check_cart);
        added=true;
      }catch(error){failure=error.message;}
      finally{
        cartAdd.preservePosition(()=>{
          unlock();root.dataset.addingBox='false';
          if(added){
            resolutionSerial++;resolutionController?.abort();
            HTMLFormElement.prototype.reset.call(form);
            groups.forEach(group=>group.querySelectorAll('[data-choice]').forEach(choice=>choice.checked=false));
            if(qty)qty.value=String(Math.max(1,Number(qty.min)||1));
            const message=form.querySelector('[name="properties[Mensagem]"]');if(message)message.value='';
          }
          update();syncQuantityControls();
          if(added&&groups.length)button.textContent=cartAdd.words().choose_options;
          if(failure&&status)status.textContent=failure;
        });
      }
      if(added)cartAdd.success();
      else cartAdd.notify(failure||cartAdd.words().error,true);
    });
    window.addEventListener('scroll',schedulePricePosition,{passive:true});
    window.addEventListener('resize',schedulePricePosition,{passive:true});
    window.visualViewport?.addEventListener('resize',schedulePricePosition,{passive:true});
    window.visualViewport?.addEventListener('scroll',schedulePricePosition,{passive:true});
    const purchaseObserver=window.ResizeObserver&&purchaseBar?new ResizeObserver(schedulePricePosition):null;
    if(purchaseObserver)purchaseObserver.observe(purchaseBar);
    const unload=event=>{
      if(!event.target.contains(root))return;
      window.removeEventListener('scroll',schedulePricePosition);
      window.removeEventListener('resize',schedulePricePosition);
      window.visualViewport?.removeEventListener('resize',schedulePricePosition);
      window.visualViewport?.removeEventListener('scroll',schedulePricePosition);
      purchaseObserver?.disconnect();
      resolutionController?.abort();
      document.removeEventListener('shopify:section:unload',unload);
    };
    document.addEventListener('shopify:section:unload',unload);
    update();
    syncQuantityControls();
    refreshPricePosition();
  });
}
document.addEventListener('DOMContentLoaded',()=>init());
document.addEventListener('shopify:section:load',e=>init(e.target));
})();
